import script from "./comp_ofertas_participante.vue?vue&type=script&setup=true&lang=js"
export * from "./comp_ofertas_participante.vue?vue&type=script&setup=true&lang=js"

import "./comp_ofertas_participante.vue?vue&type=style&index=0&id=17c5fd9f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17c5fd9f"]])

export default __exports__